<template>
  <div v-if="editedItem">
    <v-card
      color="orange"
      dark
    >
      <div class="d-flex flex-no-wrap justify-space-between">
        <div>
          <v-card-title
            class="text-h5"
            v-text="'Eventos'"
          ></v-card-title>

          <v-card-subtitle v-text="'Exportar a excel todos los eventos programados.'">

          </v-card-subtitle>
          <v-row style="width: 100%;">
            <v-col
              cols="12"
              sm="4"
              style="padding: 10px 10px 10px 30px;"
            >
              <custom-datepicker
                v-if="editedItem.StartDate"
                v-model="editedItem.StartDate"
                label="Desde"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              style="padding: 10px 20px 10px 10px;"
            >
              <custom-datepicker
                v-if="editedItem.EndDate"
                v-model="editedItem.EndDate"
                label="Hasta"
              />
            </v-col>
            <v-col
              cols="12"
              sm="4"
              style="padding: 20px 20px 10px 10px;"
            >
            </v-col>
            <v-col
              cols="12"
              sm="12"
              style="padding: 10px 20px 10px 30px;"
            >
              <v-row style="background-color: #CCCCCC80;border-radius: 10px;">
                <v-col
                  cols="12"
                  sm="12"
                  style="padding: 10px 10px 10px 30px;"
                >
                  <small>Filtros: </small>
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.BrandID"
                    :items="ab01brands"
                    label="Marca"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.AreaID"
                    :items="ab01areas"
                    label="�rea"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.HotelID"
                    :items="ab01hotels"
                    label="Hotel"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.PlanID"
                    :items="ab01plans"
                    label="Plan"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.CategoryID"
                    :items="ab01categories"
                    label="Categor�a"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="editedItem.filter.SubcategoryID"
                    :items="ab01subcategories"
                    label="Tipolog�a"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-btn
                    @click="handleGetFilteredEvents"
                    color="red"
                  >
                    Exportar todos los eventos filtrados
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              style="padding: 30px 20px 20px 30px;"
            >
              <v-row style="background-color: #CCCCCC80;border-radius: 10px;">
                <v-col
                  cols="12"
                  sm="12"
                  style="padding: 10px 10px 10px 30px;"
                >
                  <small>Configuraci�n: </small>
                </v-col>
                <template
                  v-for="(item, index) of pagesGroupBy"
                >
                <v-col
                  :key="`a${index}`"
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="pagesGroupBy[index]"
                    :items="groupsBy"
                    :label="`P�gina n�${index + 1} agrupar por:`"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col>
                <v-col
                  :key="`b${index}`"
                  cols="12"
                  sm="8"
                  style="padding: 20px 20px 10px 10px;"
                >
                  <v-btn
                    v-if="index > 0"
                    @click="() => { pagesGroupBy.splice(index, 1) }"
                    color="red"
                    style="margin-right: 10px;"
                  >
                    Quitar
                  </v-btn>
                  <v-btn
                    v-if="index === pagesGroupBy.length - 1"
                    @click="() => { pagesGroupBy.push([]) }"
                    color="green"
                  >
                    A�adir p�gina agrupada
                  </v-btn>
                </v-col>
                </template>
                <!--v-col
                  cols="12"
                  sm="4"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-select
                    v-model="countBy"
                    :items="countsBy"
                    label="Contabilizar por:"
                    item-text="Name"
                    item-value="ID"
                    outlined
                    hide-details
                    multiple
                  />
                </v-col-->
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  style="padding: 10px 20px 10px 10px;"
                >
                  <v-btn
                    @click="handleGetFilteredEventsByGroup"
                    color="blue"
                  >
                    Exportar eventos agrupados y filtrados
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  style="padding: 15px 20px 10px 10px;"
                >
                  <small>NOTA: para que muestre los contadores de asistentes, las p�ginas deben estar agrupadas.</small>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              style="padding: 10px 10px 10px 30px;"
            >
            </v-col>
          </v-row>

          <!--v-card-actions>
            <v-btn
              class="ml-2"
              outlined
              rounded
              small
              @click="handleGetEventsFiltered"
              style="margin-bottom: 10px;"
            >
              exportar excel
            </v-btn>
          </v-card-actions-->
        </div>
      </div>
    </v-card>
    <!--div v-for="item of contentTypes">
      {{item}}
      <br/>
      <br/>
    </div-->
  </div>
</template>
<script>
import * as XLSX from "xlsx"
import api from '@/services/api'
import utils from '@/services/utils'
import CustomDatepicker from '@/components/CustomDatepicker'
export default {
  components: {
    CustomDatepicker,
  },
	props: {
	},
	data: () => ({
    loading: false,
    config: null,
    editedItem: {
      filter: {}
    },
    contentTypes: [],
		values: null,
    languages: null,
    ab01areas: [],
    ab01plans: [],
    ab01categories: [],
    ab01subcategories: [{ ID: 'standard', Name: 'Est�ndar' }, { ID: 'special', Name: 'Especial'}],
    ab01brands: [],
    ab01hotels: [],
    pagesGroupBy: [[]],
    groupBY: [],
    countBy: [],
	}),
	computed: {
    locale () {
      return 'es'
    },
    minDate () {
      return '2025-02-25'
    },
    /*
    languages () {
      return ['en', 'es', 'it', 'de ', 'pt', 'fr']
    },*/
    groupsBy () {
      return [
        {
          ID: 'activity',
          Name: 'Actividad',
          Ident: 'Title',
        },
        {
          ID: 'plan',
          Name: 'Plan',
          Ident: 'Plan',
        },
        {
          ID: 'category',
          Name: 'Categor�a',
          Ident: 'Category',
        },
        {
          ID: 'subcategory',
          Name: 'Tipolog�a',
          Ident: 'Subcategory',
        },
        {
          ID: 'hotel',
          Name: 'Hotel',
          Ident: 'WorkspaceName',
        },
        {
          ID: 'area',
          Name: '�rea',
          Ident: 'Area',
        },
        {
          ID: 'brand',
          Name: 'Marca',
          Ident: 'Brand',
        },
        {
          ID: 'year',
          Name: 'A�o',
          Ident: 'Year',
        },
        {
          ID: 'month',
          Name: 'Mes',
          Ident: 'Month',
        },
      ]
    },
    countsBy () {
      return [
        {
          ID: 'plan',
          Name: 'Plan',
        },
      ]
    },
		customStyle () {
			let result = ''
			for (const row of this.rows){
				const color = row.color ? row.color : '#FFFFFF'
				result += `
										<Style ss:ID="row${row.id}">
              				<Alignment ss:Vertical="Top" />
											<Interior ss:Color="${color}" ss:Pattern="Solid"></Interior>
              				<Borders>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Right"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Left"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Top"/>
												<Border ss:Color="${color}" ss:Weight="2" ss:LineStyle="Continuous" ss:Position="Bottom"/>
              				</Borders>
											<Font ss:Color="${utils.getOppositeColor(color)}"></Font>
              			</Style>
									`
			}
			return result
		},
	},
  mounted () {
    this.handleAb01Const()
    this.editedItem.StartDate = new Date().toISOString().split('T').shift()
    this.editedItem.EndDate = new Date().toISOString().split('T').shift()
  },
  methods: {
    handleAb01Const () {
      this.ab01areas = []
      this.ab01brands = []
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/config/')
        .then(response => {
          this.ab01plans = response.map(item => {
            return {
              ID: item.id,
              Name: item.id, //utils.getTranslation(item.name, this.locale)
            }
          })
          const categories = []
          //const subcategories = []
          for (let i = 0; i < response.length; i++) {
            categories.push(...response[i].category.map(item => {
              return {
                ID: item.id,
                Name: `${utils.getTranslation(item.name, this.locale)}`
              }
            }))
            /*
            subcategories.push(...response[i].subcategory.map(item => {
              return {
                ID: item.id,
                Name: `${utils.getTranslation(item.name, this.locale)}`
              }
            }))
            */
          }
          this.ab01categories = categories
          //this.ab01subcategories = subcategories
          this.config = response
        })
        .catch (err => {
          console.log(err)
        })
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/areas/')
        .then(response => {
          this.ab01areas = response
        })
        .catch (err => {
          console.log(err)
        })
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/brands/')
        .then(response => {
          this.ab01brands = response
        })
        .catch (err => {
          console.log(err)
        })
      api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/content-types/')
        .then(response => {
          const aux = response.map(item => {
            return {
              ID: item.ID,
              Name: item.WorkspaceName.replace('BARCELO_', '')
            }
          })
          this.ab01hotels = aux
        })
        .catch (err => {
          console.log(err)
        })
    },
    getTranslation(v, locale, autoCompleteIfNull) {
      if (autoCompleteIfNull) return utils.getTranslation(v, locale)
      return v ? v[locale] : null
    },
    prepareDate (v) {
      if (!v) return
      const date = new Date(v)
      return `${utils.pad(date.getDate())}/${utils.pad((date.getMonth() + 1))}/${date.getFullYear()}`
    },
    convertTime (v) {
      if (!v) return '00:00'

      const h = v / 60 | 0
      const m = v - (h * 60)
      return `${h} : ${utils.pad(m)}`
    },
		prepareData (v, languages) {
			const result = []
      for (const event of v) {
        const aux = {}

        aux['Plan'] = event.PlanID
        aux['Category'] = event.CategoryID
        aux['Subcategory'] = event.SubcategoryID
        //title
        for (const l of languages) {
          aux[`Name (${l})`] = event.Title ? this.getTranslation(JSON.parse(event.Title), l, true) : ''
        }
        aux['Image'] = event.Image
        /*
        //aux['D�a'] = event.Date	
        aux['D�a'] = this.prepareDate(event.Date)
        aux['Hora Inicio'] = event.Time ? this.convertTime(event.Time).split(' ').join('') : null
        aux['Hora Fin'] = event.TimeEnd ? this.convertTime(event.TimeEnd).split(' ').join('') : null
        for (const l of this.languages) {
          aux[`Actividad (${l})`] = this.getTranslation(JSON.parse(event.Title), l, true)
        }
        
        aux[`Locacion`] = this.getTranslation(JSON.parse(event.Place), 'es')

        aux['ID'] = event.ID
        aux['Imagen'] = event.Image
        
        for (const l of this.languages) {
          aux[`Descripci�n (${l})`] = event.Description ? this.getTranslation(JSON.parse(event.Description), l, true) : ''
        }
        aux[`Reservable`] = event.Reservable ? 'reservable' : null
        aux[`PVP alojado`] = event.Reservable ? event.PVPHosted : null
        aux[`Cupos`] = event.Reservable ? event.PAX : null
        //aux[`PVP no alojado`] = event.Reservable ? event.PVPNoHosted : null
        */
        /*
        for (const l of this.languages) {
          aux[`Ubicaci�n (${l})`] = this.getTranslation(JSON.parse(event.Place), l)
        }
        */
        result.push(aux)
      }

			return result
		},
		prepareDataEventsFiltered (v, languages, byGroup = null) {
			const result = []
      for (const event of v) {
        const aux = {}

        if (byGroup && byGroup.length > 0) {
          for (let i = 0; i < byGroup.length; i++) {
            const g = this.groupsBy.filter(x => x.ID === byGroup[i]).shift()
            if (g) {
              if (g.Ident === 'Title') {
                for (const l of languages) {
                  aux[g.Name] = event.Title ? this.getTranslation(JSON.parse(event.Title), l, true) : ''
                }
              } else {
                aux[g.Name] = event[g.Ident]
              }
            }
          }
          aux['Count'] = event.Count
          aux['Adultos'] = event.Adults
          aux['Ni�os'] = event.Children
        } else {
          aux['Hotel'] = event.WorkspaceName
          aux['�rea'] = event.Area
          aux['Marca'] = event.Brand
          aux['Plan'] = event.Plan
          aux['Category'] = event.Category
          aux['Subcategory'] = event.Subcategory
          //title
          for (const l of languages) {
            aux[`Actividad (${l})`] = event.Title ? this.getTranslation(JSON.parse(event.Title), l, true) : ''
          }
          aux['D�a'] = event.Date	
          aux['Hora Inicio'] = event.Time ? this.convertTime(event.Time).split(' ').join('') : null
          aux['Hora Fin'] = event.TimeEnd ? this.convertTime(event.TimeEnd).split(' ').join('') : null
          aux['Adultos'] = event.Adults
          aux['Ni�os'] = event.Children
        }

        /*
        aux['D�a'] = this.prepareDate(event.Date)
        for (const l of this.languages) {
          aux[`Actividad (${l})`] = this.getTranslation(JSON.parse(event.Title), l, true)
        }
        
        aux[`Locacion`] = this.getTranslation(JSON.parse(event.Place), 'es')

        aux['ID'] = event.ID
        aux['Imagen'] = event.Image
        
        for (const l of this.languages) {
          aux[`Descripci�n (${l})`] = event.Description ? this.getTranslation(JSON.parse(event.Description), l, true) : ''
        }
        aux[`Reservable`] = event.Reservable ? 'reservable' : null
        aux[`PVP alojado`] = event.Reservable ? event.PVPHosted : null
        aux[`Cupos`] = event.Reservable ? event.PAX : null
        //aux[`PVP no alojado`] = event.Reservable ? event.PVPNoHosted : null
        */
        /*
        for (const l of this.languages) {
          aux[`Ubicaci�n (${l})`] = this.getTranslation(JSON.parse(event.Place), l)
        }
        */
        result.push(aux)
      }

			return result
		},
		getValue (weekID, mealID, rowID, optionID, day) {
			const aux = this.values.filter(x => 
                  x.Week === weekID &&
                  x.Row === rowID &&
                  x.Meal === mealID &&
                  x.Day === day.toString() &&
                  (!optionID || x.Option === optionID)
                ).map(item => item.Value).shift()
      return aux ? aux : ''
		},
		async handleExport () {
      try {

        this.loading = true
        const contentTypes = await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', 'v1/private/activity-barcelo-01/excel/content-types/')
            .then(response => {
              response.unshift({ ID: null, WorkspaceName: 'Corporativo' })
              resolve(response.map(item => {
                return {
                  ID: item.ID,
                  Name: item.WorkspaceName,
                  Languages: item.Languages ? JSON.parse(item.Languages) :  ["es", "en", "de", "it", "pt", "fr"]
                }
              }))
            })
          .catch (err => {
            reject(err)
          }))
        if (contentTypes) {
          for(let i = 0; i < contentTypes.length; i++) {
            contentTypes[i].Events = await new Promise((resolve, reject) => api.getAllWithoutLimit ('dviewcontent', `v1/private/activity-barcelo-01/excel/content-type-events/${contentTypes[i].ID ? contentTypes[i].ID : ''}`)
                .then(response => {
                  resolve(response)
                })
              .catch (err => {
                reject(err)
              }))
          }
        }
        this.contentTypes = contentTypes
        this.handleCreateExcel(contentTypes)
      /*
      this.languages = await new Promise((resolve, reject) => api.getItem ('dviewcontent', 'v1/public/workspaces/', this.workspaceID)
          .then(response => {   
            resolve(response.Languages ? JSON.parse(response.Languages) : [])
          })
        .catch (err => {
          reject(err)
        }))
      const url = `v1/public/activity-barcelo/${this.contentTypeDataID}/excel`
      api.getAll ('dviewcontent', url, 0, 1000, '')
        .then(response => {
          if (this.contentTypeData.Show) {
            this.handleCreateExcel(`Calendario - Show.xls`, `Show`, response)
          } else {
            for (const category of this.contentTypeData.Categories) {
              this.handleCreateExcel(`Calendario - ${this.getTranslation(category.Name, 'es')}.xls`, `${this.getTranslation(category.Name, 'es')}`, response.filter(x => x.CategoryID === category.ID))
            }
          }
          this.loading = false
        })
        .catch (error => {
          console.log(error)
          this.loading = false
        })
      */
      } catch (error) {
        console.log(error)
      }
    },

    /*
    handleCreateExcel (fileName, pageName, data) {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const wb = XLSX.utils.book_new()

      const ws = XLSX.utils.json_to_sheet(this.prepareData(data))
      XLSX.utils.book_append_sheet(wb, ws, pageName)

			const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });

			const fileData = new Blob([excelBuffer], { type: fileType });
			var link = document.createElement("A")
			link.href = URL.createObjectURL(fileData)
			link.download = fileName
			link.target = '_blank'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
    */
    handleCreateExcel (v) {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const wb = XLSX.utils.book_new()

      for (const page of v) {
        const ws = XLSX.utils.json_to_sheet(this.prepareData(page.Events, page.Languages))
        XLSX.utils.book_append_sheet(wb, ws, page.Name.replace('BARCELO_', '').substring(0,30))
      }

			const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });

			const fileData = new Blob([excelBuffer], { type: fileType });
			var link = document.createElement("A")
			link.href = URL.createObjectURL(fileData)
			link.download = 'ActivityBarcelo.xls'
			link.target = '_blank'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
    handleCreateEventsFilteredExcel (v, byGroup = null) {
      const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
      const wb = XLSX.utils.book_new()

      if (byGroup) {
        for (let i = 0; i < byGroup.length; i++) {
          const ws = XLSX.utils.json_to_sheet(this.prepareDataEventsFiltered(v[i], ['es'], byGroup[i]))
          XLSX.utils.book_append_sheet(wb, ws, `PAG ${i+1}`)
        }
      } else {
        const ws = XLSX.utils.json_to_sheet(this.prepareDataEventsFiltered(v, ['es'], null))
        XLSX.utils.book_append_sheet(wb, ws, 'Eventos')
      }

			const excelBuffer = XLSX.write(wb, { bookType: "xls", type: "array" });

			const fileData = new Blob([excelBuffer], { type: fileType });
			var link = document.createElement("A")
			link.href = URL.createObjectURL(fileData)
			link.download = byGroup ? 'ActivityBarceloEventosAgrupados.xls' : 'ActivityBarceloEventos.xls'
			link.target = '_blank'
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
		},
    handleGetFilteredEvents () {
      api.put('dviewcontent', `v1/private/activity-barcelo-01/excel/events/`, this.editedItem)
        .then(response => {
          //console.log('events', response.data.length, response.data)
          this.handleCreateEventsFilteredExcel(response.data.map(item => {
            item.WorkspaceName = item.WorkspaceName.replace('BARCELO_', '')
            item.Area = this.ab01areas.filter(x => x.ID===item.Area).map(i => i.Name).shift()
            item.Brand = this.ab01brands.filter(x => x.ID===item.Brand).map(i => i.Name).shift()
            item.Plan = item.PlanID//this.ab01plans.filter(x => x.ID===item.PlanID).map(i => i.Name).shift()
            item.Category = this.ab01categories.filter(x => x.ID===item.CategoryID).map(i => i.Name).shift()
            item.Subcategory = this.ab01subcategories.filter(x => x.ID===item.SubcategoryID).map(i => i.Name).shift()
            return item
          }))
        })
        .catch (err => {
          console.log(err)
        })
    },
    /*
    handleGetFilteredEventsByGroup () {
      const body = JSON.parse(JSON.stringify(this.editedItem))
      body.groupBy = this.groupBy
      api.put('dviewcontent', `v1/private/activity-barcelo-01/excel/events/`, body)
        .then(response => {
          //console.log('events', response.data.length, response.data)
          this.handleCreateEventsFilteredExcel(response.data.map(item => {
            if (item.WorkspaceName) item.WorkspaceName = item.WorkspaceName.replace('BARCELO_', '')
            if (item.Area) item.Area = this.ab01areas.filter(x => x.ID===item.Area).map(i => i.Name).shift()
            if (item.Brand) item.Brand = this.ab01brands.filter(x => x.ID===item.Brand).map(i => i.Name).shift()
            if (item.PlanID) item.Plan = item.PlanID//this.ab01plans.filter(x => x.ID===item.PlanID).map(i => i.Name).shift()
            if (item.CategoryID) item.Category = this.ab01categories.filter(x => x.ID===item.CategoryID).map(i => i.Name).shift()
            if (item.SubcategoryID) item.Subcategory = this.ab01subcategories.filter(x => x.ID===item.SubcategoryID).map(i => i.Name).shift()
            return item
          }), this.groupBy)
        })
        .catch (err => {
          console.log(err)
        })
    },
    */
    async handleGetFilteredEventsByGroup () {
      try {

        const body = JSON.parse(JSON.stringify(this.editedItem))
        const pages = []
        for (let i = 0; i < this.pagesGroupBy.length; i++) {
          body.groupBy = this.pagesGroupBy[i]
          pages.push(await new Promise((resolve, reject) => api.put('dviewcontent', `v1/private/activity-barcelo-01/excel/events/`, body)
            .then(response => {
              //console.log('events', response.data.length, response.data)
              resolve(response.data.map(item => {
                if (item.WorkspaceName) item.WorkspaceName = item.WorkspaceName.replace('BARCELO_', '')
                if (item.Area) item.Area = this.ab01areas.filter(x => x.ID===item.Area).map(i => i.Name).shift()
                if (item.Brand) item.Brand = this.ab01brands.filter(x => x.ID===item.Brand).map(i => i.Name).shift()
                if (item.PlanID) item.Plan = item.PlanID//this.ab01plans.filter(x => x.ID===item.PlanID).map(i => i.Name).shift()
                if (item.CategoryID) item.Category = this.ab01categories.filter(x => x.ID===item.CategoryID).map(i => i.Name).shift()
                if (item.SubcategoryID) item.Subcategory = this.ab01subcategories.filter(x => x.ID===item.SubcategoryID).map(i => i.Name).shift()
                return item
              }), this.groupBy)
            })
            .catch (err => {
              reject(err)
            }))
          )
        }
        this.handleCreateEventsFilteredExcel(pages, this.pagesGroupBy)
      } catch (error) {
        alert('error')
        console.log(error)
      }
    },
  },
}
</script>



